exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chart-tooltip {\n  background-color: #f7f8fb;\n  border: 1px solid #e4e4e4;\n  border-radius: 3px;\n  padding: 10px; }\n  .chart-tooltip .tooltip-title {\n    font-size: 14px;\n    text-align: center;\n    display: inline-block; }\n    .chart-tooltip .tooltip-title .tooltip-value {\n      display: inline-block; }\n    .chart-tooltip .tooltip-title .tooltip-label {\n      font-weight: 800;\n      display: inline-block; }\n  .chart-tooltip ul {\n    margin-top: 5px; }\n    .chart-tooltip ul .metric {\n      font-weight: 800;\n      font-size: 12px; }\n    .chart-tooltip ul .value {\n      font-weight: 400;\n      font-size: 14px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Chart/common/Tooltip/style.scss
// module id = 1037
// module chunks = 0